module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"service_table.field.service_no":"ใบงาน","service_table.field.open_detail":"รับเรื่อง","service_table.field.status.service":"สถานะใบงาน","service_table.field.status.repair":"งานซ่อม","service_table.field.status.payment":"ชำระเงิน"}}')
  delete Component.options._Ctor
}
